export const SHOW_TURNTABLE = 'SHOW_TURNTABLE_CFQ'
export const SET_TURNTABLE_SIZE = 'SET_TURNTABLE_SIZE_CFQ'
export const SET_RESULT_SELECTED = 'SET_RESULT_SELECTED_CFQ'
export const SET_MODE = 'SET_MODE_CFQ'
export const SET_CHOICES = 'SET_CHOICES_CFQ'
export const SET_HISTORY = 'SET_HISTORY_CFQ'
export const SET_CONTINENTS_ACTIVE = 'SET_CONTINENTS_ACTIVE_CFQ'
export const SET_SHOW_MODE = 'SET_SHOW_MODE_CFQ'
export const SET_TITLE_OBJ = 'SET_TITLE_OBJ_CFQ'
export const INSTANT_INIT = 'INSTANT_INIT_CFQ'
export const RESET_INITIAL_STATE = 'RESET_INITIAL_STATE_CFQ'
export const REPLACE_STATE = 'REPLACE_STATE_CFQ'
export const SET_MYSTERY_WHEEL_ON = 'SET_MYSTERY_WHEEL_ON_CFQ'
export const SET_MYSTERY_RESULT_ON = 'SET_MYSTERY_RESULT_ON_CFQ'
export const UPDATE_MYSTERY_SETTINGS = 'UPDATE_MYSTERY_SETTINGS_CFQ'
export const SET_SCORES = 'SET_SCORES_CFQ'
export const SET_AUTO_ADD_COUNT = 'SET_AUTO_ADD_COUNT_CFQ'
export const SYNC_INPUTS_SETTINGS = 'SYNC_INPUTS_SETTINGS_CFQ'
export const SET_ANSWER_CHOICE_COUNT = 'SET_ANSWER_CHOICE_COUNT_CFQ'
